import React from "react";
import logo from "../../assets/images/accor-plus-logo.png";
import accorCard from "../../assets/images/accorplus-card.png";

const CardAsset = () => {
  return (
    <div className="accorplus-card mx-auto flex justify-items-start xs:hidden">
      <img src={accorCard} alt="accor-card" />
    </div>
    // <div className="card-asset shadow-lg relative xs:hidden">
    //     {/* hello world */}
    //     <div className="card-asset-logo flex justify-center items-center mx-auto flex-col">
    //       <img src={logo} alt="logo"/>
    //       {/* <div className="card-asset-text absolute bottom-0 flex mb-5 justify-between items-end w-full">
    //         <span className="card-text mx-5" id="card-name">{cardMemberName}</span>
    //         <span className="card-text mx-5" id="card-id">{cardMemberId}</span>
    //       </div> */}
    //     </div>
    // </div>
  );
};

export default CardAsset;
